require('./products-edit-images-container.scss')

module.exports = {
  template: require('./products-edit-images-container.pug')()
  controller: require('./products-edit-images-container.ctrl')
}
